import React, { Component } from 'react';
import {Route, withRouter} from 'react-router';
import ScrollToTopRoute from './ScrollToTopRoute.js';
import Footer from './Footer.js';
import {Link, BrowserRouter, Switch} from 'react-router-dom';
import './App.css';
import Order from './order.js';
import Home from './home.js';
import ComponentNotFound from './componentNotFound';
import ConfirmOrder from './confirmOrder.js';
import logo from './images/PÖfi-logo.svg';
import { Images, DOMAIN, WP_SUB_DIRECTORY } from './consts.js'


class App extends Component {

  toggleNav = (e) => {
    const navCon = e.target.nextElementSibling
    if (navCon.classList.contains('visible')) {
      navCon.classList.remove('visible');
    } else {
      navCon.classList.add('visible');
    }
  }


  render() {
    return (
      <BrowserRouter>
      <div className="App container-fluid p-0">

      <div className="nav-container">
      <nav className="custom-navbar">

        <div className="logo-container float-left">
          <Link to='/'><img src={logo} className="app-logo" alt ="" /></Link>
        </div>
        <div className="nav-menu-wrapper-mobile">
          <div className="nav-menu-icon-container" onClick={this.toggleNav}>
          <img src={Images['menu-icon.svg']} className="nav-menu-icon" alt="" />
          </div>
          <div className="nav-menu-container">
            <ul>
              <li><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/`}>Lämmitysöljy</a></li>
              <li><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/polttooljy/`}>Polttoöljy</a></li>
              <li><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/miksipofi/`}>Miksi Pö.fi</a></li>
              <li><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/usein-kysyttya`}>Usein kysyttyä</a></li>
              <li><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/yhteystiedot`}>Yhteystiedot</a></li>
            </ul>
          </div>
        </div>
        <div className="nav-menu-wrapper-desktop float-right">
          <ul className="menu">
            <li className="menu-item"><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/`}>Lämmitysöljy</a></li>
            <li className="menu-item"><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/polttooljy/`}>Polttoöljy</a></li>
            <li className="menu-item"><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/miksipofi/`}>Miksi Pö.fi</a></li>
            <li className="menu-item"><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/usein-kysyttya`}>Usein kysyttyä</a></li>
            <li className="menu-item"><a href={`${DOMAIN}/${WP_SUB_DIRECTORY}/yhteystiedot`}>Yhteystiedot</a></li>
          </ul>
        </div>

      </nav>
      </div>

      <div className="content">
      <Switch>

        <ScrollToTopRoute exact path='/' component={Home}/>
        <ScrollToTopRoute path='/order' component={Order}/>
        <ScrollToTopRoute path='/confirm-order' component={ConfirmOrder}/>
        <ScrollToTopRoute component={ComponentNotFound} />

      </Switch>
      </div>

      <Footer />

      </div>
      </BrowserRouter>

    )
  }

}

export default App;
